import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import { map, indexOf } from 'lodash'

import { allowedCodes } from './constants'

import './style.scss'

export default class ScoringLabels extends Component {
    static propTypes = {
        code: PropTypes.string,
        creditLimit: PropTypes.number,
        labels: PropTypes.array,
        translates: PropTypes.shape({
            criteriaText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            criteriaTitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    static defaultProps = {
        labels: [],
    }

    render() {
        const {
            labels,
            translates: { criteriaText, criteriaTitleText },
            creditLimit,
            code,
        } = this.props

        return (
            <div className={'scoring-labels'}>
                <div className={'scoring-criteria-title'}>{criteriaTitleText}</div>
                <div className={'scoring-labels-wrap'}>
                    {map(labels, (label, key) => (
                        <div key={`bisnode-scoring-label-${key}`} className={cx('scoring-label', label && label)} />
                    ))}
                </div>
                {!!(creditLimit?.amount && creditLimit?.amount > 0 && indexOf(allowedCodes, code) !== -1) && (
                    <div className={'scoring-criteria-wrap'}>
                        <div className={'scoring-criteria-icon'} />
                        <div className={'scoring-criteria-text'}>{criteriaText}</div>
                    </div>
                )}
            </div>
        )
    }
}
